'use client'
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/button.ts
var BUTTON_QUERY = `
id
label
href
theme
shape
iconPosition
icon {${IMAGE_QUERY}}
arrow
`;

export {
  BUTTON_QUERY
};
//# sourceMappingURL=chunk-OYEMYN5L.mjs.map